import {createSlice} from '@reduxjs/toolkit'

const initialReportsState = {
  hotelPurchase: {
    data: [],
    total: 0,
    loading: false,
  },
  transferPurchase: {
    data: [],
    total: 0,
    loading: false,
  },
  sightseeingPurchase: {
    data: [],
    total: 0,
    loading: false,
  },
}

export const ReportsSlices = createSlice({
  name: 'reports',
  initialState: initialReportsState,
  reducers: {
    setHotelPurchaseLoading: (state, action) => {
      state.hotelPurchase.loading = action.payload
    },
    setHotelPurchase: (state, action) => {
      state.hotelPurchase.data = action.payload.data
      state.hotelPurchase.total = action.payload.total
      state.hotelPurchase.loading = false
    },
    setTransferPurchaseLoading: (state, action) => {
      state.transferPurchase.loading = action.payload
    },
    setTransferPurchase: (state, action) => {
      state.transferPurchase.data = action.payload.data
      state.transferPurchase.total = action.payload.total
      state.transferPurchase.loading = false
    },
    setSightseeingPurchaseLoading: (state, action) => {
      state.sightseeingPurchase.loading = action.payload
    },
    setSightseeingPurchase: (state, action) => {
      state.sightseeingPurchase.data = action.payload.data
      state.sightseeingPurchase.total = action.payload.total
      state.sightseeingPurchase.loading = false
    },
  },
})

export const {
  setHotelPurchaseLoading,
  setHotelPurchase,
  setTransferPurchaseLoading,
  setTransferPurchase,
  setSightseeingPurchaseLoading,
  setSightseeingPurchase,
} = ReportsSlices.actions
